export const getComplaintsNetworkData = ({ networkComplaints }) =>
  networkComplaints.networkComplaints;
export const getComplaintsNetworkCount = ({ networkComplaints }) =>
  networkComplaints.networkComplaintsCount;
export const getFailsLoading = ({ networkComplaints }) =>
  networkComplaints.loaders.common;
export const getError = ({ networkComplaints }) =>
  networkComplaints.errors.error;
export const getSuccess = ({ networkComplaints }) =>
  networkComplaints.success.success;
export const getOpenComplaintsNetworkSelector = ({ networkComplaints }) =>
  networkComplaints.openComplaintsNetwork;
export const getEventsNextPage = ({ networkComplaints }) =>
  networkComplaints.nextPage;
